import * as React from "react";
import Assets from "src/presentation/assets/img/assets";

export const stars = (point: number) => {
  switch (Math.floor(point)) {
    case 0:
      return (
        <div>
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
        </div>
      );
    case 1:
      return (
        <div>
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
        </div>
      );
    case 2:
      return (
        <div>
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
        </div>
      );
    case 3:
      return (
        <div>
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
        </div>
      );
    case 4:
      return (
        <div>
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.starGray} />
        </div>
      );
    case 5:
      return (
        <div>
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
          <img style={{ width: 25, height: 25 }} src={Assets.star} />
        </div>
      );
  }

  return <></>;
};



// WEBPACK FOOTER //
// ./src/presentation/component/client/customer/stars.tsx